import { render, staticRenderFns } from "./MapTab5.vue?vue&type=template&id=24bf5bc7&scoped=true"
import script from "./MapTab5.vue?vue&type=script&lang=js"
export * from "./MapTab5.vue?vue&type=script&lang=js"
import style0 from "./MapTab5.vue?vue&type=style&index=0&id=24bf5bc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf5bc7",
  null
  
)

export default component.exports